import React, { Component } from "react";

import { Link } from "react-router-dom";

import { connect } from "react-redux";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";
import { Helmet } from "react-helmet";

class RightBicepCurls extends Component {
  state = {
    menuToggled: false,
  };

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  render() {
    return (
      <div>
        <Helmet>
          <title>The Ultimate Bicep Curls Exercises</title>

          <meta
            name="description"
            content="At the front of the upper arm, curls work the
              biceps muscles, as well as the lower arm
              muscles-the brachialis and brachioradialis."
          />

          <meta
            property="og:url"
            content="https://www.boxfit-fitness.com/ultimate-bicep-curls"
          />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="At the front of the upper arm, curls work the
              biceps muscles, as well as the lower arm
              muscles-the brachialis and brachioradialis."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://cdn.fitzet.com/static%2Fbicepcurls.jpg?alt=media"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          {/*this.state.menuToggled ? <MenuFunc off={this.setmenuoff} /> : null*/}
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div className="Screen">
          <div style={{ padding: "55px 20px 20px 20px" }}>
            <h2>The Ultimate Bicep Curls Exercises</h2>
            <div style={{ display: "flex" }}>
              <div className="notmobile">
                <img
                  src="https://cdn.fitzet.com/static%2Fbicepcurls.jpg?alt=media"
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="bicep curls curls Exercises"
                />
              </div>

              <div className="notmobile">
                <img
                  src="https://cdn.fitzet.com/static%2Farmopenelbowlift.jpg?alt=media"
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="bicep curls Exercises"
                />
              </div>

              <div className="notmobile">
                <img
                  src="https://cdn.fitzet.com/static%2Farmsinglearmreverseflyleft.jpg?alt=media"
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="bicep curls Exercises"
                />
              </div>
            </div>
            <p
              style={{
                fontSize: "18px",
                textAlign: "left",
                /*textJustify: "distribute",
                textAlignLast: "left",
                width: "100%",*/
              }}
            >
              At the front of the upper arm, curls work the{" "}
              <strong>biceps muscles</strong>, as well as the lower arm
              muscles-the brachialis and brachioradialis.
            </p>

            <p
              style={{
                fontSize: "18px",
                textAlign: "left",
                /*textJustify: "distribute",
                textAlignLast: "left",
                width: "100%",*/
              }}
            >
              Whenever you pick anything up, you use these muscles, which is
              normal in everyday life. You <strong>generate strength</strong> in
              the upper arm by doing the standing arm curl and learn to use your
              arm muscles properly, bracing with your core muscles.
            </p>

            <p
              style={{
                fontSize: "18px",
                textAlign: "left",
                /*textJustify: "distribute",
                textAlignLast: "left",
                width: "100%",*/
              }}
            >
              Here at <strong>BoxFit</strong>, we've hand-picked the best bicep
              curls exercises for you. Click the button below to start your
              bicep curls workout session.
            </p>

            <p style={{ fontSize: "18px", marginTop: "20px" }}>
              <button
                style={{
                  fontSize: "18px",
                  background: "#69C9D0",
                  padding: "10px",
                  border: 0,
                  borderRadius: "4px",
                  fontWeight: "600",
                  width: "100%",
                  color: "white",
                }}
                onClick={() => {
                  this.props.history.push({
                    pathname: "/start-workout/arm",
                  });
                }}
              >
                Commencer l'entraînement{" "}
                <span role="img" aria-label="like">
                  🔥
                </span>
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(RightBicepCurls);
